import { Component } from "@angular/core";

@Component({
  selector: "icon-cargando-tramite",
  templateUrl: "./cargando.svg",
  standalone: true,
})
export class CargandoTramiteIconComponent {}
